var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"visit-body"},_vm._l((_vm.data),function(el,i){return _c('Single',{key:i,attrs:{"id":`procedure-${i}`,"category":"procedure","data":el}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }